export default function Accordion() {
  if (document.querySelector('.accordion-group-block')) {
    const accordions = document.querySelectorAll('.accordion-group-block__item');
    const accordionOpenClass = 'accordion-group-block__item--is-open';

    accordions.forEach(accordion => {
      accordion.querySelector('h3').addEventListener('click', () => toggleAccorrdion(accordion));
    });

    function toggleAccorrdion(accordion) {
      if (accordion.classList.contains(accordionOpenClass)) {
        accordion.classList.remove(accordionOpenClass);
        accordion.querySelector('.accordion-group-block__item-content').setAttribute('aria-hidden', true);
      } else {
        accordion.classList.add(accordionOpenClass);
        accordion.querySelector('.accordion-group-block__item-content').setAttribute('aria-hidden', false);
      }
    }
  }
};
